<template>
  <div class="beta">
    <div class="container">
      <div class="inner">
        <img class="logo" src="@/assets/nklogo_.png" width="150" />

        <h1>パスワードの再設定</h1>

        <p>入力して頂いたメールアドレスに、パスワード再設定用のメールを送信します。</p>

        <div class="guide-container">
          <p class="guide"></p>
        </div>

        <el-form label-width="150px">
          <el-form-item label="メールアドレス" prop="name">
            <el-input type="email" autocomplete="on" v-model="email"></el-input>
          </el-form-item>

          <div class="button-container">
            <button
              @click.prevent="sendResetMail"
              class="button register"
              :class="[{'loading disabled': loading}, {'disabled': email.length < 1}]"
            >{{ loading ? '送信中' : '送信'}}</button>
          </div>
        </el-form>

        <!-- <el-alert
          title="メールを送信しました"
          type="success"
          description="ご入力頂いたメールアドレスに確認用のメールを送信しました。メールに記載されているURLをクリックして本登録を完了してください。"
          show-icon
        ></el-alert>-->

        <button class="button white" style="margin-top: 20px" @click="back">サインインページに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "ForgotPassword",
  data() {
    return {
      loading: false,
      err: false,
      errCode: "",
      errDescription: "",
      email: ""
    };
  },
  mounted(){
    document.title = "ネイティブの口 | パスワードの再発行";

  },
  methods: {
    back() {
      this.$router.replace("/");
    },
    sendResetMail() {
      this.loading = true;
      let self = this;
      if (self.email.length < 0) {
        self.$notify({
          type: "error",
          title: "失敗",
          duration: 0,
          message: `メールアドレスが入力されていません`
        });
        return;
      }
      const auth = firebase.auth();
      auth
        .sendPasswordResetEmail(self.email)
        .then(function() {
          self.$notify({
            type: "success",
            title: "成功",
            duration: 0,
            message: `ご使用のメールアドレスに、パスワード再設定に必要なURLを送信しました。URLをクリックして引き続きパスワードの変更手続きをお願いします。`
          });
          self.$router.replace("/");
        })
        .catch(function(err) {
          self.loading = false;
          self.$notify({
            type: "error",
            title: "失敗",
            duration: 0,
            message: `入力されたメールアドレスは無効です。`
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  text-align: left;
  margin: 35px 0;
}
.inner {
  max-width: 50%;
  margin: 0 auto;
}

.button-container {
  text-align: center;
}

.register {
  margin: 20px 0;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.guide-container {
  margin: 30px;
  font-weight: bold;
}
</style>